import React from "react";
import "../stylesheets/Scroll.css";

class Scroll extends React.Component {
  componentDidMount() {
    if (document.body.clientHeight < window.innerHeight) {
      const scroll = document.getElementsByClassName("scroll-container");

      scroll[0].style.display = "none";
    }

    const inner = document.getElementsByClassName("circle");

    let callNum = false;

    function arrowMovement() {
      callNum = !callNum;

      if (!callNum) {
        inner[0].style.top = "50%";
        inner[0].style.opacity = "0";
        inner[0].style.transition = "all 1s";
      }
      if (callNum) {
        inner[0].style.top = "-50%";
        inner[0].style.opacity = "1";
        inner[0].style.transition = "all 0.3s";
      }
    }

    this.interval = setInterval(() => arrowMovement(), 800);

    window.addEventListener("scroll", this.handleScroll);
  }

  componentWillUnmount() {
    clearInterval(this.interval);

    window.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll = (e) => {
    const scroll = document.getElementsByClassName("scroll-container");

    if (window.scrollY >= 290) {
      scroll[0].style.transition = "all 0.5s ease";
      scroll[0].style.opacity = "0";
    } else if (window.scrollY <= 200) {
      scroll[0].style.transition = "all 0.5s ease";
      scroll[0].style.opacity = "1";
    }
  };

  render() {
    return (
      <div className="scroll-container">
        <div className="scroll">
          <div className="circle"></div>
        </div>
      </div>
    );
  }
}

export default Scroll;
